//console.log("product page loaded");

var slideIcon = document.getElementById("slide_icon");
var BannerCon = document.getElementsByClassName("Banner_Container");
var EachSlide = document.getElementsByClassName("Each_Silde");
var prevButton = document.getElementsByClassName("Prev_btn");
var nextButton = document.getElementsByClassName("next_btn");

var iconThumb = document.getElementsByClassName("icon_Each");
if (slideIcon !== null) {
  BannerCon[0].style.width = EachSlide.length * 100 + "%";
  var OffsetWidth = EachSlide[0].offsetWidth;
  var index = 0;

  slideIcon.setAttribute("class", "icon_container");

  for (i = 0; i < EachSlide.length; i++) {
    var content = EachSlide[i].dataset.title;
    var iconEach = document.createElement("div");
    iconEach.innerText = content;
    iconEach.setAttribute("class", "icon_Each");
    slideIcon.append(iconEach);
  }

  [].forEach.call(
    document.getElementsByClassName("icon_container")[0].children,
    function (elem) {
      elem.addEventListener("click", function () {
        var value = FindDivContent(elem.innerText);

        if (index != value[0]) {
          index = value[0];
          OffsetImage(1, 1, value[1]);
          iconThumb_Active(index);
        }
      });
    }
  );

  function FindDivContent(someText) {
    var container = BannerCon[0].children;
    for (l = 0; l < container.length; l++) {
      if (container[l].dataset.title == someText) {
        return [l, l * container[l].offsetWidth];
      }
    }
  }

  function OffsetImage(dir, ind, width) {
    if (dir == 1) {
      BannerCon[0].style.transform =
        "translate(-" + parseInt(ind) * width + "px)";
    }
  }

  function iconThumb_Active(IndexValue) {
    //
    for (m = 0; m < iconThumb.length; m++) {
      if (iconThumb[m].classList.contains("icon_Each-active") == true) {
        iconThumb[m].classList.remove("icon_Each-active");
      }
      iconThumb[IndexValue].classList.add("icon_Each-active");
    }
  }

  window.document.onload = iconThumb[0].classList.add("icon_Each-active");
}

$("#review").on("click", function () {
  $(".SetionHolder").find("#tab-3").css("display", "block");
  $("#tab-3").show().siblings(".eachsec").hide();
  $("#reviewtitle").addClass("active");
  $(".overview_Title").removeClass("active");
  $(".Spec_Title").removeClass("active");
  $(".Simliar_Title").removeClass("active");
});

//Added by sharath

var panres = document.getElementById("myresult");
var divContaineres = document.getElementsByClassName(
  "product-single__info-wrapper"
);
// console.log(panres);
//console.log(divContaineres);
panres.style.width = divContaineres[0].offsetWidth + "px";
if (!divContaineres[0].offsetHeight >= 400)
  panres.style.height = divContaineres[0].offsetHeight + "px";


// on hover zoom effect

function imageZoom(imgID, resultID) {
  var img, lens, result, cx, cy, pos, x, y;
  img = document.getElementById(imgID);
  result = document.getElementById(resultID);

  /*create lens:*/
  lens = document.createElement("DIV");
  lens.setAttribute("class", "img-zoom-lens");

  /*insert lens:*/
  img.parentElement.insertBefore(lens, img);
  /*calculate the ratio between result DIV and lens:*/
  cx = result.offsetWidth / lens.offsetWidth; //result.offsetWidth
  cy = result.offsetHeight / lens.offsetHeight;
  /*set background properties for the result DIV:*/
  var featuredImage = document.getElementsByClassName('product-single__thumbnail');

  // console.log(featuredImage);

  result.style.backgroundSize = img.width * cx + "px " + img.height * cy + "px";


  result.style.display = "none";
  lens.style.display = "none";

  img.addEventListener("mouseover", movehover);
  lens.addEventListener("mouseover", movehover);

  lens.addEventListener("mousemove", moveLens);
  img.addEventListener("mousemove", moveLens);

  img.addEventListener("mouseout", moveleave);
  lens.addEventListener("mouseout", moveleave);


  function movehover(e) {

    if (templateSuffix == 'repacked' && !thumbnailChecker) {
      document.getElementById('repackTag').style.display = "none";
    }
    lens.style.display = "block";
    result.style.display = "block";
    pos = getCursorPos();
    var insertx = lens.offsetWidth;
    var inserty = lens.offsetHeight;

    var diffx = pos.x - insertx;
    var diffy = pos.y - inserty;

    result.style.backgroundImage = "url('" + img.src + "')";
  }

  function moveleave(e) {
    if (templateSuffix == 'repacked' && !thumbnailChecker) {
      document.getElementById('repackTag').style.display = "block";
    }

    lens.style.display = "none";
    result.style.display = "none";
  }

  function moveLens(e) {
    var pos, x, y;

    e.preventDefault();

    /*get the cursor's x and y positions:*/

    pos = getCursorPos(e);

    /*calculate the position of the lens:*/

    x = pos.x - lens.offsetWidth / 2;

    y = pos.y - lens.offsetHeight / 2;

    /*prevent the lens from being positioned outside the image:*/

    if (x > img.width - lens.offsetWidth) {
      x = img.width - lens.offsetWidth;
    }

    if (x < 0) {
      x = 0;
    }

    if (y > img.height - lens.offsetHeight) {
      y = img.height - lens.offsetHeight;
    }

    if (y < 0) {
      y = 0;
    }

    /*set the position of the lens:*/

    lens.style.left = x + "px";
    lens.style.top = y + "px";

    /*display what the lens "sees":*/

    result.style.backgroundPosition = "-" + x * cx + "px -" + y * cy + "px"; //"-" + (x * cx) + "px -" + (y * cy) + "px";
    result.style.backgroundSize = img.width * (cx) + "px " + img.height * (cy) + "px"; //(img.width * cx) + "px " + (img.height * cy) + "px";
    result.style.backgroundRepeat = "no-repeat";
  }

  function getCursorPos(e) {
    var a,
      x = 0,
      y = 0;

    e = e || window.event;
    /*get the x and y positions of the image:*/
    a = img.getBoundingClientRect();
    /*calculate the cursor's x and y coordinates, relative to the image:*/
    x = e.pageX - a.left;
    y = e.pageY - a.top;
    /*consider any page scrolling:*/
    x = x - window.pageXOffset;
    y = y - window.pageYOffset;
    return { x: x, y: y };
  }
}


imageZoom(sectionID, "myresult");



document
  .getElementById("NotificationSuccess")
  .getElementsByClassName("notification__close")[0]
  .addEventListener("click", function () {
    document
      .getElementById("NotificationSuccess")
      .classList.remove("notification--active");
  });

document
  .getElementById("NotificationError")
  .getElementsByClassName("notification__close")[0]
  .addEventListener("click", function () {
    document
      .getElementById("NotificationError")
      .classList.remove("notification--active");
  });

document
  .getElementById("NotificationSuccess-mob")
  .getElementsByClassName("notification__close")[0]
  .addEventListener("click", function () {
    document
      .getElementById("NotificationSuccess-mob")
      .classList.remove("notification--active");
  });

document
  .getElementById("NotificationError-mob")
  .getElementsByClassName("notification__close")[0]
  .addEventListener("click", function () {
    document
      .getElementById("NotificationError-mob")
      .classList.remove("notification--active");
  });

//Modal for pincode feature
var modal_CX_RW = document.getElementById("my_CX_RW");
var btn_CX_RW = document.getElementById("CX_RW");
//var span_CX_RW = document.getElementsByClassName("close_CX_RW")[0];
var resultPin;

// span_CX_RW.addEventListener("click", function () {
//   modal_CX_RW.style.display = "none";
// });

// if (btn_CX_RW != undefined) {
//   btn_CX_RW.addEventListener("click", function () {
//     if (modal_CX_RW.style.display == "block") {
//       modal_CX_RW.style.display = "none";
//     } else {
//       modal_CX_RW.style.display = "block";
//     }
//   });
// }
// window.onclick = function (event) {
//   if (event.target == modal_CX_RW) {
//     modal_CX_RW.style.display = "none";
//   }
// };

//Warranty Icon near Product Image.
var warranty = document.getElementById("warranty");
var prodWarranty = document.getElementById("Wrty");
var prodWarrantyMob = document.getElementById("WrtyM");
if (warranty != null) {
  if (warranty.dataset.warranty == "1") {
    prodWarranty.innerHTML = warranty.dataset.warranty + " Year";
    prodWarrantyMob.innerHTML = warranty.dataset.warranty + " Year";
  } else if (warranty.dataset.warranty == "Lifetime") {
    prodWarranty.innerHTML = warranty.dataset.warranty;
    prodWarrantyMob.innerHTML = warranty.dataset.warranty;
  } else {
    prodWarranty.innerHTML = warranty.dataset.warranty + " Years";
    prodWarrantyMob.innerHTML = warranty.dataset.warranty + " Years";
  }
} else {
  document.getElementById("WrtyCont").style.display = "none";
  document.getElementById("WrtyContM").style.display = "none";
}

//accordion for Product page
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

// Restricts input for the given textbox to the given inputFilter.
function setInputFilter(textbox, inputFilter) {
  [
    "input",
    "keydown",
    "keyup",
    "mousedown",
    "mouseup",
    "select",
    "contextmenu",
    "drop",
  ].forEach(function (event) {
    textbox.addEventListener(event, function () {
      if (inputFilter(this.value)) {
        this.oldValue = this.value;
        this.oldSelectionStart = this.selectionStart;
        this.oldSelectionEnd = this.selectionEnd;
      } else if (this.hasOwnProperty("oldValue")) {
        this.value = this.oldValue;
        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
      } else {
        this.value = "";
      }
    });
  });
}

var pincodeTextCode = document.getElementById("textcode");

if (pincodeTextCode != null) {
  setInputFilter(pincodeTextCode, function (value) {
    return (
      /^\d*$/.test(value) &&
      (value === "" || parseInt(value) <= 999999 || parseInt(value) == 0)
    );
  });
}



//Share button on toggle function
$("#shareId").click(function () {
  $("#shareIcon").toggle();
});

jQuery(window).on("load", function () {
  //alert('page is loaded');
  //console.log(resultPinLockDown);
  //console.log(resultPinLockDownDefault);
});
let pincodeNew;
let COO;




//Camelcase the String
function camelize(str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
    if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
    return index === 0 ? match.toUpperCase() : match.toLowerCase();
  });
}

//File reader object
let AjaxCallProd =
{
  asyncReadFileFromAsset: function (pathOfFileToReadFrom, fileMethod) {
    //console.log(pathOfFileToReadFrom);
    let obj;
    $.ajax({
      url: pathOfFileToReadFrom,
      async: false,
      dataType: "text",
      success: function (response) {
        if (fileMethod == 'COO') {
          // console.log(response);
          obj = CSVTOJson_Convertor(response, 'COO');
        }
        else {
          obj = CSVTOJson_Convertor(response);
        }
      },
      error: function (jqXHR, exception) {
        obj = jqXHR.status;
      }
    })

    return (obj);

  }
};

function CSVTOJson_Convertor(data, convert) {

  if (convert == 'COO') {
    var array = {};
    var allRows = data.split(/\r?\n|\r/);

    let category = allRows[0].split(',');

    for (var singleRow = 1; singleRow < allRows.length - 1; singleRow++) {
      var rowCells = allRows[singleRow].split(',');

      var arrayCat = [];
      let Brand = rowCells[0].toLowerCase();

      for (var SingleCol = 1; SingleCol < rowCells.length; SingleCol++) {
        var EachCells = rowCells[SingleCol];
        //let obj = {}
        arrayCat[category[SingleCol].toLowerCase()] = EachCells;
        // let obj = {
        //   'Category':,
        //   'value': EachCells
        // }

        //arrayCat.push(obj);
      }

      //let obj = {}
      array[Brand] = arrayCat;

      //array.push(obj);
    }
  }

  else {
    var array = [];
    var allRows = data.split(/\r?\n|\r/);
    //console.log(allRows);
    for (var singleRow = 0; singleRow < allRows.length; singleRow++) {
      var rowCells = allRows[singleRow].split(',');
      let object = {
        Pin: "",
        City: "",
        State: "",
        Dispatch_Block: "",
        Tier: ""
      }

      //let objectCreate = Object.create(object);

      if (rowCells != "" && rowCells[0] != 'Pin') {
        object.Pin = rowCells[1];
        object.City = rowCells[0];
        object.State = rowCells[5];
        object.Dispatch_Block = rowCells[7];
        object.Tier = rowCells[6];
        array.push(object)
      }
    }

  }

  return array;
}